<template>
    <div></div>
</template>

<script>
export default {
    async mounted() {
        const mno = +this.$route.params.mno;
        const cryptoToken = this.$route.params.pathMatch;

        await this.$store.dispatch('account/loginFromAccCenter', { mno, cryptoToken });
        const GRP_NO = localStorage.getItem('grP_NO');

        const company_id = localStorage.getItem('company');
        switch (GRP_NO) {
        case 'OT1':
        case 'OT2':
        case 'OT4':
        case 'OT5':
        case 'OT6':
            this.$router.replace({ name: 'accounting-summary', params: { company_id } });
            break;
        case 'OT3':
            this.$router.replace({ name: 'accounting-business-tax', params: { company_id } });
            break;
        default:
            this.$router.replace({ name: 'index', params: { company_id } });
        }
    },
};
</script>
